import { ModalForm, TextArea, AfterSubmitProps, FormFieldsData } from 'framework/form';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { useShowContext } from 'framework/show';
import { DocumentStorageItemType } from 'framework/documentStorage';
import { EMPLOYEE_DOCUMENT_STAGES_ALIAS } from '../../../constants';

const AnnulEmployeeDocumentAction = ({
  modalOpen,
  closeModal,
  afterSubmit,
}: {
  modalOpen: boolean;
  closeModal: () => void;
  afterSubmit: AfterSubmitProps<(response: FormFieldsData) => void>;
}) => {
  const { data } = useShowContext<DocumentStorageItemType>();
  const { editDocument } = useDocumentStorageContext();

  const documentData = data.getData();

  return (
    <>
      <ModalForm
        getValidationSchemaFunc={() =>
          Promise.resolve({
            annullingReason: {
              type: 'string',
              required: true,
            },
          })
        }
        modalOpen={modalOpen}
        closeModal={closeModal}
        handleDirty
        submitFormFunc={editDocument}
        afterSubmit={{
          ...afterSubmit,
        }}
        initialData={{
          annullingReason: '',
          ...documentData.metadata,
          stage: EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
          paths: [documentData.path],
        }}
      >
        <TextArea source="annullingReason" label="Please, enter the annul reason" />
      </ModalForm>
    </>
  );
};

export default AnnulEmployeeDocumentAction;
